<template>
  <div>
    <hr color="B3C3EC">
    <div class="detailwrap" v-if="passChangeTableVisible">
      <!-- 密码修改 -->
      <div class="detailbg">
        <el-row>
          <el-col :span="6">&nbsp;</el-col>
          <el-col :span="16">
            <div class="detailLine">
              <span class="detailLabel">用 户 I D：</span>
              <span class="detailValue">{{this.fantasyUserBO.userName}}</span>
            </div>
            <div class="detailLine">
              <span class="detailLabel">新的密码：</span>
              <span class="detailValue"><el-input type="password" size="mini" placeholder="请输入新密码" class="password" maxlength=20 v-model.trim="newPass"/></span>
            </div>
            <div class="detailLine">
              <span class="detailLabel">重输密码：</span>
              <span class="detailValue"><el-input type="password" size="mini" placeholder="请重新输入新密码" class="password" maxlength=20 v-model.trim="newPass2"/></span>
            </div>
            <div class="detailLine">
              <el-button type="success" icon="el-icon-check"  @click="changePass();"></el-button>
            </div>
          </el-col>
          <el-col :span="2"></el-col>
        </el-row>
      </div>
    </div>
    <div class="detailwrap" v-if="passChangeTableVisible==false">
      <!-- 密码修改 -->
      <div class="detailbg">
        <el-row>
          <el-col :span="6">　</el-col>
          <el-col :span="16">
            <div class="detailLine">
              {{message}}
            </div>
          </el-col>
          <el-col :span="2"></el-col>
        </el-row>
      </div>
    </div>
    <el-footer class="footer">
      <el-row>
        <el-col :span="24">
          <div class="copyright">
            ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="advice">
            抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>
<script>
  import {postJson} from '../../utils/api'
  import {putRequest} from '../../utils/api'
  import {getRequest} from '../../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    data(){
      return {
        passChangeTableVisible: false,
        newPass: "",
        newPass2: "",
        message: "",
        fantasyUserBO: {},
        emailVerifyCode: ""
      }
    },
    mounted: function () {
      var _this = this;
      this.initForm();
    },
    methods: {
        initForm() {
          let emailVerifyCode = this.$route.query.emailVerifyCode;
          getRequest('/auth/mail/changePasswordFromEmail', {
            emailVerifyCode: emailVerifyCode||''
          }).then(resp=> {
            if (resp.status == 200) {
              //成功
              var respData = resp.data;
              if (200 == respData.status) {
                this.fantasyUserBO = respData.data.fantasyUserBO;
                this.emailVerifyCode = respData.data.emailVerifyCode;
                this.passChangeTableVisible = true;
              } else {
                //失败
                this.message = respData.message;
                this.passChangeTableVisible = false;
              }
            } else {
              //失败
              Message.error('用户非法⊙﹏⊙∥!');
              this.passChangeTableVisible = false;
            }
          }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
            this.$router.replace({path: '/'});
          });
        },
        //修改密码
        changePass() {
          if (this.newPass != this.newPass2) {
            Message.warning('两次输入的新密码不一致,请检查', '提示');
            return;
          }
          var _this = this;
          postJson('/auth/mail/changePasswordByEmail', {
            emailVerifyCode: this.emailVerifyCode,
            newPass: this.newPass
          }).then(resp=> {
            if (resp.status == 200) {
            //成功
            var respData = resp.data;
            if (200 == respData.status) {
              this.passChangeTableVisible = false;
              this.newPass = "";
              this.newPass2 = "";
              Message.success(respData.message);
              this.$router.replace({path: '/'});
            } else {
              Message.error(respData.message);
            }
            } else {
              //失败
              Message.error('用户非法⊙﹏⊙∥!1');
            }
          }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!2');
          });
        }
    },
  }
  
</script>
<style scoped>
.detailwrap {
    margin:auto;
    width: 80%;
}
.detailLabel {
    color: #7d7a75;
}
.detailValue {
    color: #92655f;
}
.detailwrap .nickName {
	width: 100px;
}
.detailwrap hr {
	margin-top: 5px;
	margin-bottom: 5px;
}
.detailLine {
	line-height: 50px;
}
.detailwrap .password {
	width: 150px;
}
  

.footer a {
    cursor: pointer;
    color: #333;
    text-decoration:none;
}
.footer a:hover {text-decoration:underline;color:#FF0000}
.footer .copyright {
  margin: 5px auto;
  text-align: center;
  font-size: 14px;
  color: #333;
}
.footer .advice {
  margin: 0;
  text-align: center;
  font-size: 12px;
  color: #444;
}
</style>
